import styled from 'styled-components';
import {
  size,
  layout,
  color,
  flexbox,
  position,
  space,
  typography,
  border,
  overflow,
  background,
  system,
} from 'styled-system';

import { Colors } from '@nakedplatform/ui';
import { VARIANTS } from 'theme/variants';

const { transformOrigin, transform } = VARIANTS.transforms;
const { fontWeight } = VARIANTS.typography;

/**
 * Provides the basic layout for the app
 */

export const Container = styled.div<App.Theme.Layout.ContainerProps>`  
  ${background}
  ${border}
  ${color} 
  ${flexbox}
  ${layout} 
  ${overflow}
  ${position} 
  ${size} 
  ${space}
  ${typography}
  ${transform}
  ${transformOrigin}
  ${system({
    flexFlow: {
      property: 'flexFlow',
    },
    float: true,
  })}
`;

export const Section = styled(Container)``;

export const IconContainer = styled(Container)`
  border-radius: 50%;
  width: 50px;
  height: 50px;
  background-color: ${Colors.oceanGreen};
`;

export const HR = styled.hr`
  width: 100%;
  max-width: 100%;
  border-bottom: 1px solid ${Colors.gallery};
  margin: 0px;
  clear: both;
  height: 0;
  border-top: 0;
  border-right: 0;
  border-left: 0;
`;

export const UnorderedList = styled.ul<App.Theme.Font.FontProps>`
  margin: 0px 1rem 0px 50px;
  padding: 0;
  margin-bottom: 1rem;
  list-style: disc;
  ${typography}
  ${fontWeight}
  ${space}
  ${color}
`;

export const OrderedList = styled.ol<App.Theme.Font.FontProps>`
  float: none;
  display: block;
  margin-left: 1em;
  margin-right: 0px;
  margin-top: 0px;
  padding: 0px;
  list-style: decimal;
  ${typography}
  ${fontWeight}
`;

export const Link = styled('a')`
  text-decoration: none;
  cursor: pointer;
`;
